export default __webpack_public_path__ + "static/media/coresanscr25it-webfont.a978ff54.woff";